import {Theme} from 'common/constants';
import {System} from 'common/models/system';

const {theme} = window.YC;

export default {
    error: null,
    theme: theme || Theme.Light,
} as System;
